interface WallClockParts {
  year: number;
  month: number;
  day: number;
  hour: number;
  minute: number;
  second: number;
}

export const parseWallClock = (iso: string): WallClockParts | null => {
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?/.exec(iso);
  if (!m) return null;
  return {
    year: Number(m[1]),
    month: Number(m[2]),
    day: Number(m[3]),
    hour: Number(m[4]),
    minute: Number(m[5]),
    second: m[6] ? Number(m[6]) : 0,
  };
};

const pad2 = (n: number): string => String(n).padStart(2, '0');

export const formatWallClockTime = (iso: string): string => {
  const p = parseWallClock(iso);
  if (p) return `${pad2(p.hour)}:${pad2(p.minute)}`;
  const d = new Date(iso);
  return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
};

export const wallClockHour = (iso: string): number => {
  const p = parseWallClock(iso);
  return p ? p.hour : new Date(iso).getHours();
};

export const wallClockMinutes = (iso: string): number => {
  const p = parseWallClock(iso);
  if (p) return p.hour * 60 + p.minute;
  const d = new Date(iso);
  return d.getHours() * 60 + d.getMinutes();
};

export const wallClockDate = (iso: string): string => {
  const p = parseWallClock(iso);
  if (p) return `${p.year}-${pad2(p.month)}-${pad2(p.day)}`;
  const d = new Date(iso);
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
};

export const wallClockTimeOfDay = (iso: string): string => {
  const p = parseWallClock(iso);
  if (p) return `${pad2(p.hour)}:${pad2(p.minute)}:${pad2(p.second)}`;
  const d = new Date(iso);
  return `${pad2(d.getHours())}:${pad2(d.getMinutes())}:00`;
};

export const buildWallClockIso = (date: string, time: string): string => {
  const hhmm = time.length === 5 ? `${time}:00` : time;
  return `${date}T${hhmm}+00:00`;
};

export const shiftWallClockIso = (iso: string, hours: number): string => {
  const shifted = new Date(Date.parse(buildWallClockIso(wallClockDate(iso), wallClockTimeOfDay(iso))) + hours * 3_600_000);
  const p = {
    year: shifted.getUTCFullYear(),
    month: shifted.getUTCMonth() + 1,
    day: shifted.getUTCDate(),
    hour: shifted.getUTCHours(),
    minute: shifted.getUTCMinutes(),
  };
  return `${p.year}-${pad2(p.month)}-${pad2(p.day)}T${pad2(p.hour)}:${pad2(p.minute)}:00+00:00`;
};
